module.exports = __webpack_public_path__ + "img/solutionBanner_5.940a4419.png";